import { createSlice } from '@reduxjs/toolkit';

export const ErrorSlice = createSlice({
    name: 'error',
    initialState: {
        error: null,
        status: null
    },
    reducers: {
        // setError: (state, action) => {
        //     if (action.payload instanceof Object) {
        //         state.error = action.payload.detail;
        //         state.status = action.payload.status;
        //     } else console.log('wrong format of error obj');
        // },
        setError: (state, action) => {
            if (action.payload instanceof Object) {
                if (action.payload.status === 401) window.location.replace(`${process.env.REACT_APP_DOMAIN}`);

                state.error = action.payload.detail || action.payload.message;
                state.status = action.payload.status;

                let elementApp = document.getElementById('App');
                elementApp.scrollIntoView({ behavior: "smooth" });
            } else console.log('wrong format of error obj');
        },
        delError: (state) => {
            state.error = null;
            state.status = null;
        }
    }
})

export const { setError, delError} = ErrorSlice.actions;

export default ErrorSlice.reducer;